export class IntegrationAlreadyExistsError extends Error { }
